<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Laporan Ekspedisi</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<div v-if="false">
						<v-tabs light color="primary lighten-1" background-color="deep-purple lighten-5" class="change-display" height="40">
							<v-tab @click="cardDisplay = true">
								<v-icon>mdi-card-bulleted</v-icon>
							</v-tab>
							<v-tab @click="cardDisplay = false">
								<v-icon>mdi-table</v-icon>
							</v-tab>
						</v-tabs>
					</div>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary lighten-1 mr-2">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn class="primary lighten-1" text dark @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="py-0">
					<v-row>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="No. Ekspedisi" v-model="shipment_code.value" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="Armada" v-model="armada.value" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="Plat" v-model="plat.value" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="Driver" v-model="driver.value" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" >
							<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="35" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field label="Tanggal Ekspedisi" outlined dense hide-details append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :value="convertDate(shipment_date.value)"></v-text-field>
								</template>
								<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="menu = false" v-model="shipment_date.value"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="Supervisor" v-model="supervisor.value" color="primary lighten-1"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" class=""></v-col>
						<v-col cols="12" md="3" class="my-auto text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
							<v-btn depressed color="primary lighten-1" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-card>
		</v-slide-y-transition>
		<div>
			<v-card class="mb-3" outlined v-for="expedition in listExpedition" :key="expedition.shipment_id">
				<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
					<v-list-item dense>
						<v-list-item-content class="grey--text text--darken-2">
							No. Ekspedisi {{ expedition.shipment_code }}
						</v-list-item-content>
						<v-spacer></v-spacer>
					</v-list-item>
				</v-list>
				<v-list-item>
					<v-list-item-content>
						<v-layout wrap>
							<v-flex xs6 sm4 md4 class="pr-2">
								<div>
									<div class="body-2 oppacity-75">Armada</div>
									<div class="subtitle-2">{{ expedition.shipment_vehicle_name }}</div>
								</div>
								<div class="pt-2">
									<div class="body-2 oppacity-75">Plat</div>
									<div class="subtitle-2">{{ expedition.shipment_vehicle_registration_number }}</div>
								</div>
							</v-flex>
							<v-flex xs6 sm3 md3 class="pr-2">
								<div>
									<div class="body-2 oppacity-75">Driver</div>
									<div class="subtitle-2 text-capitalize">{{ expedition.shipment_driver_name }}</div>
								</div>
								<div class="pt-2">
									<div class="body-2 oppacity-75">Supervisor</div>
									<div class="subtitle-2">{{ expedition.shipment_supervisor }}</div>
								</div>
							</v-flex>
							<v-flex xs6 sm3 md3 class="pr-2">
								<div>
									<div class="body-2 oppacity-75">Tanggal Ekspedisi</div>
									<div class="subtitle-2 text-capitalize">{{ expedition.shipment_datetime | tanggal }}</div>
								</div>
								<div class="pt-2">
									<div class="body-2 oppacity-75">Status Ekspedisi</div>
									<div class="subtitle-2">{{ expedition.shipment_status | statusExpedition }}</div>
								</div>
							</v-flex>
							<v-flex xs6 sm2 md2 class="pr-2">
								<div class="d-flex justify-space-between">
									<div class="body-2 oppacity-75">Jumlah Destinasi</div>
									<div class="subtitle-2">{{ expedition.shipment_total_quantity | toNumber }}</div>
								</div>
								<div class="pt-2 d-flex justify-space-between">
									<div class="body-2 oppacity-75">Jumlah Muatan</div>
									<div class="subtitle-2">{{ expedition.shipment_total_package | toNumber }}</div>
								</div>
								<div class="pt-2 d-flex justify-space-between">
									<div class="body-2 oppacity-75">Berat Total</div>
									<div class="subtitle-2">{{ expedition.shipment_total_weight_kilogram | toKg }}</div>
								</div>
							</v-flex>
							<v-flex xs6 sm3 md3 v-if="false">
								<div class="pt-4">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" class="mr-2">
												<v-icon dark>mdi-text-box-search</v-icon>
											</v-btn>
										</template>
										<span>Detail</span>
									</v-tooltip>
								</div>
							</v-flex>
						</v-layout>
					</v-list-item-content>
				</v-list-item>
			</v-card>
		</div>
		<div class="pt-5">
			<v-row>
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<div>
						<v-pagination v-model="page" :length="expeditionPagination.total_page" total-visible="5" circle class="d-flex justify-end no-button-focus" color="primary lighten-1" @input="changePage"></v-pagination>
					</div>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="primary lighten-1" @input="changeLimit"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data () {
		return {
			cardDisplay: false,
			dropfilter: false,
			menu: false,
			page: 1,
			limit: 10,
			listLimit: [ '5', '10', '20', '50', '100' ],
			params:[],
			shipment_code: {
				value:'',
				comparison:'like',
				type:'string',
				field:'shipment_code'
			},
			armada: {
				value:'',
				comparison:'like',
				type:'string',
				field:'shipment_vehicle_name'
			},
			plat: {
				value:'',
				comparison:'like',
				type:'string',
				field:'shipment_vehicle_registration_number'
			},
			driver: {
				value:'',
				comparison:'like',
				type:'string',
				field:'shipment_driver_name'
			},
			shipment_date: {
				value:'',
				comparison:'=',
				type:'string',
				field:'shipment_datetime'
			},
			supervisor: {
				value:'',
				comparison:'like',
				type:'string',
				field:'shipment_supervisor'
			},
		}
	},
	computed: {
		...mapState('expedition', ['listExpedition', 'expeditionPagination']),
	},
	methods: {
		...mapActions('expedition', ['getExpedition']),

		cari() {
			this.params = []
			if(this.shipment_code.value)
				this.params.push(this.shipment_code)

			if(this.armada.value)
				this.params.push(this.armada)

			if(this.plat.value)
				this.params.push(this.plat)

			if(this.driver.value)
				this.params.push(this.driver)

			if(this.shipment_date.value)
				this.params.push(this.shipment_date)

			if(this.supervisor.value)
				this.params.push(this.supervisor)

			this.getExpedition(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		resetFilter() {
			this.shipment_code.value = ''
			this.armada.value = ''
			this.plat.value = ''
			this.driver.value = ''
			this.shipment_date.value = ''
			this.supervisor.value = ''
			this.params = []
			this.limit = 10
			this.getExpedition(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		changePage(page) {
			this.page = page
			this.getExpedition(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getExpedition(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Laporan Ekspedisi`)
		this.getExpedition()
	}
};

</script>
